<template>
    <div class="body">
        <div class="shoppic" :style="{'height':isShow ? 'auto' : '400px'}">
            <div class="yinying"></div>
            <div class="svg_btn" @click="isShow = !isShow">
                <img src="@/assets/sf/up.svg" alt="" v-if="!isShow"/>
                <img src="@/assets/sf/down.svg" alt="" v-if="isShow"/>
            </div>
            <div class="description">
                <img :src="img1" alt="" />
                <img :src="img2" alt="" />
            </div>
        </div>
        <div class="fix-cell__title">
            <div class="van-cell__title">套餐名称</div>
            <div class="van-cell__value">{{pkgName}}</div>
        </div>
        <div class="cell-title">实名信息</div>
        <van-cell-group>
            <van-field v-model="dataFrom.takeNickname" :rules="[{ pattern: /[\u4e00-\u9fa5]{2}/, message: '不能为数字、字母、特殊符号且不少于2个汉字！'}]"  clearable label="姓名:" placeholder="请输入真实姓名(已加密)" />
            <van-field  v-model="dataFrom.idCard" clearable label="身份证号:" placeholder="16岁以下禁止申请（已加密）" />
            <van-field v-model="dataFrom.takePhone" maxlength="11"   clearable label="联系号码:" placeholder="请输入11位手机号(已加密)" />
        </van-cell-group> 
        <div class="cell-title">填写配送地址</div>
        <van-cell-group>
            <van-field readonly v-model="dataFrom.pcaAddress" clearable label="收货地址:" placeholder="请选择省市区" @focus="showAddressVisible()"/>
            <van-field v-model="dataFrom.takeAddress" clearable label="详细地址:" placeholder="街道/小区/门牌号等" />
        </van-cell-group> 
        <van-popup v-model="dataFrom.addressVisible" position="bottom">
            <van-area
                :area-list="areaList"
                :columns-placeholder="['请选择', '请选择', '请选择']"
                @cancel="cancelSelectAddress()"
                @confirm="selectAddress"
            />
        </van-popup>
        <div class="v-ht">
            根据有关部门要求，必须上传真实身份证照片。
            <span style="color: red;">未上传照片，订单无效。</span>
        </div>
        <van-row class="v-sf-img">
            <van-col span="12">
                <van-uploader v-model="fileList" :max-count="1" :after-read="afterRead" :before-delete="beforeDelete" />
            </van-col>
            <van-col span="12">
                <img src="@/assets/sf/face.png" alt="" />
            </van-col>
        </van-row>
        <div class="uploader-tip">证件四角边缘空隙2厘米以上，手机横拍，照片清晰不模糊，无水印，无反光，无PS</div>
        <van-row class="v-sf-img">
            <van-col span="12">
                <van-uploader v-model="fileList1" :max-count="1" :after-read="afterRead1" :before-delete="beforeDelete1" />
            </van-col>
            <van-col span="12">
                <img src="@/assets/sf/back.png" alt="" />
            </van-col>
        </van-row>
        <div class="uploader-tip">证件四角边缘空隙2厘米以上，手机横拍，照片清晰不模糊，无水印，无反光，无PS</div>
         <van-row class="v-sf-img">
            <van-col span="12">
                <van-uploader v-model="fileList2" :max-count="1" :after-read="afterRead2" :before-delete="beforeDelete2" />
            </van-col>
            <van-col span="12">
                <img src="@/assets/sf/head.png" alt="" />
            </van-col>
        </van-row>
        <div class="uploader-tip">无需手持身份证，胸部以上，露出双肩，人像面部比例不低于1/3，无水印，无反光，无PS</div>
        <div class="uploader-tip1">*请填写真实身份信息，未满16岁、一证五号、信息错误将无法发货。</div>
        <van-button round type="info" class="btnButton" @click="sunmbitFn()">提交信息</van-button>
    </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import areaListData from "@/utils/Area.js";
import { Toast  } from 'vant';

export default {
    data(){
        return {
            isShow:false,
            fileList:[],
            fileList1:[],
            fileList2:[],
             froms:'',
             pkgName:'',
            areaList:areaListData,
            dataFrom:{
                takeNickname:'' ,
                provinceCode:'',
                cityCode:'',
                addressVisible:false,
                takePhone:'',
                takeAddress:'',
                pcaAddress:'',
                idCard:'',
                backUrl:{},
                frontUrl:{},
                headUrl:{},
                img1:'',
                img2:'',
                froms:'',
            }
        }
    },
   created(){
			 this.froms= this.$route.query.froms;
			 this.dataFrom.froms= this.$route.query.froms;
            var data={
              froms: this.dataFrom.froms
            }
			  wxRequest('applyChangeSim/apply/sim/info',data, 'post').then(res => {
                if(res.data.code == 200){
                    this.pkgName=res.data.data.name;
                    this.img1= process.env.VUE_APP_IMG_URL + '/' + res.data.data.titleImg;
                    this.img2= process.env.VUE_APP_IMG_URL + '/' +res.data.data.infoImg;
                  
                }else {
                    Toast.fail(res.data.message);
                    return;
                }
            })
		},
    methods:{
        afterRead(data){
            console.log(data)
           this.dataFrom.backUrl = data.file
        },
        afterRead1(data){
           this.dataFrom.frontUrl =data.file
        },
        afterRead2(data){
            this.dataFrom.headUrl = data.file
        },
        beforeDelete(data){
            this.fileList = []
            this.dataFrom.backUrl = {}
        },
        beforeDelete1(data){
            this.fileList1 = []
            this.dataFrom.frontUrl = {}
        },
        beforeDelete2(data){
            this.fileList2 = []
            this.dataFrom.headUrl = {}
        },
        sunmbitFn(){
            if(!this.dataFrom.backUrl.lastModified){
                Toast.fail('请上传身份证正面');
                return
            }
            if(!this.dataFrom.frontUrl.lastModified){
                Toast.fail('请上传身份证反面');
                return
            }
            if(!this.dataFrom.headUrl.lastModified){
                Toast.fail('请上传正面照片');
                return
            }
            var formData = new FormData()
            Object.keys(this.dataFrom).forEach(item=>{
                formData.append(item, this.dataFrom[item]);
            })
            wxRequest('/applyChangeSim/apply/sim/my/from',formData, 'post').then(res => {
                if(res.data.code == 200){
                    Toast.fail('提交成功');
                }else {
                    Toast.fail(res.data.message);
                }
            })
        },
        selectAddress(values){
				if(!values[0].code || values[0].code.length<1){
					Toast.fail('请选择地区');
					return ;
				}

				if(!values[1].code || values[1].code.length<1){
					Toast.fail('请选择地区');
					return ;
				}

				if(!values[2].code || values[2].code.length<1){
					Toast.fail('请选择地区');
					return ;
				}

				if(values[0].code == '110000' || values[0].code == '120000' || 
					values[0].code == '310000' || values[0].code == '500000'){
					this.addressTmp = values[0].name + values[2].name
				}else{
					this.addressTmp = values[0].name + values[1].name + values[2].name
				}   
				this.dataFrom.pcaAddress = values[0].name +'-'+ values[1].name +'-'+ values[2].name;
				this.dataFrom.addressVisible = false;
			},
			cancelSelectAddress() {
			    this.dataFrom.pcaAddress = "";
			    this.dataFrom.addressVisible = false;
			},
			showAddressVisible() {
			    this.dataFrom.addressVisible = true;
			},
    }
}
</script>
<style lang="less" scoped>
    .preview-cover {
        position: absolute;
        bottom: 0;
        box-sizing: border-box;
        width: 100%;
        padding: 4px;
        color: #fff;
        font-size: 12px;
        text-align: center;
        background: rgba(0, 0, 0, 0.3);
    }
    .body{
        height:100%;
        width: 100%;
        .shoppic{
            overflow: hidden;
            position: relative;
            height: 400px;
            .yinying{
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 60px;
                background: url('../../assets/sf/bg.png')no-repeat center;
                background-size: 100% 100%;
            }
            .svg_btn{
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                text-align: center;
                animation: myfirs_a 1.5s infinite;
            }
            .description{
                width:100%;
                img{
                    display: block;
                    width:100%;
                }
            }
            @keyframes myfirs_a {
                0% {
                    transform: translate(0px, 0px);
                }

                50% {
                    transform: translate(0px, -10px);
                }

                100% {
                    transform: translate(0px, 0px);
                }
            }
        }
        .fix-cell__title{
            width: 100%;
            display: flex;
            padding: 10px 15px;
            box-sizing: border-box;
            line-height: 24px;
            position: relative;
            background-color: #fff;
            color: #333;
            font-size: 14px;
            overflow: hidden;
            border-bottom:1px solid #dedede;
            .van-cell__title{
                max-width: 90px;
                flex: 1;
            }
            .van-cell__value{
                flex: 1;
                overflow: hidden;
                text-align: left;
                position: relative;
                vertical-align: middle;
                color: rgb(117, 117, 126);
            }
        }
        .cell-title{
            color: #3976ff;
            font-size: 12px;
            padding: 10px 14px 10px 23px;
            margin: 0;
            position: relative;
            &::before{
                content: ' ';
                position: absolute;
                width: 2px;
                height: 9px;
                top: 50%;
                left: 14px;
                transform: translate(0, -4.5px);
                background: #3976ff;
            }
            &::after{
                content: ' ';
                position: absolute;
                pointer-events: none;
                box-sizing: border-box;
                top: -50%;
                left: -50%;
                right: -50%;
                bottom: -50%;
                transform: scale(.5);
                border: 1px solid #eee;
            }
        }
        .v-ht{
            color: rgb(17, 17, 17);
            padding: 20px;
            font-size: 14px;
            line-height:20px;
            box-sizing: border-box;
            font-weight: bold;
        }
        .v-sf-img{
            .van-col--12{
                text-align: center;
                img{
                    height:100px;
                }
                .van-uploader{
                    width:150px;
                    height:100px;
                    ::v-deep .van-uploader__upload{
                        height:100px;
                        width:150px;
                    }
                    ::v-deep .van-image{
                        height:100px;
                        width:150px;
                    }
                    
                }
            }
        }
        .uploader-tip{
            color: #333;
            font-size: 12px;
            text-align: left;
            width: 90%;
            line-height:20px;
            margin:20px auto;
        }
        .uploader-tip1{
            border-top:1px solid #dedede;
            font-size: 12px;
            line-height:20px;
            color: rgb(204, 204, 204);
            padding: 15px 15px 0px;
        }
        .btnButton{
            width: 90%;
            background: #3976ff;
            border-radius: 0.3rem;
            font-size: 15px;
            color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            outline: #3976ff;
            margin:16px auto;
            border-color: #3976ff;
        }
    }
</style>